<template lang="html">
  <v-page>
    <v-topbar />
    <v-breadcrumb
      :steps="[
        /* {label:'Dashboard', to: {name:'client-dashboard'}}, */
        { label: 'Vibbrantes' },
      ]"
    />

    <v-container>
      <v-input id="testee" v-model="teste_model"
        >TESTE MODEL {{ teste_model }}</v-input
      >
      <v-input
        type="select"
        :options="teste_model_select_options"
        v-model="teste_model_select"
        >TESTE MODEL {{ teste_model_select }}</v-input
      >
      <v-input
        id="testeeee"
        type="datepicker"
        minimumView="month"
        maximumView="month"
        v-model="teste_model_date"
      >
        TESTE MODEL {{ teste_model_date }}
      </v-input>
      <v-input type="range" :min="7" :max="12" v-model="teste_model_range"
        >TESTE MODEL {{ teste_model_range }}</v-input
      >
      <v-input id="coisssa" type="checkbox" v-model="teste_model_checkbox"
        >TESTE teste_model_checkbox {{ teste_model_checkbox }}</v-input
      >{{ teste_model_checkbox }}
      <!-- <input type="text" name="" v-model="teste_model">
    <input type="range" name="" v-model="teste_model_number" :min="7" :max="12"> -->
    </v-container>
  </v-page>
</template>

<script>
export default {
  data() {
    return {
      teste_model: 'texto de teste!',
      teste_model_number: 3,
      teste_model_range: [9, 11],
      teste_model_date: '',
      teste_model_checkbox: true,
      teste_model_select: 4,
      teste_model_select_options: [1, 2, 3, 4, 5, 6],
      user_modal_show: false,
      user_justification_modal_show: false,
      user_question_modal_show: false,
      client_cancel_contract_modal_show: false,
    };
  },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/parts/pages/examples/form.vue